import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer-section-2 fix footer-bg">
      <div className="bg-color">
        <img src="assets/images/home-2/footer-bg-color.png" alt="img" />
      </div>
      <div className="footer-shape">
        <img src="assets/images/home-2/footer-shape.png" alt="img" />
      </div>
      <div className="auto-container">
        <div className="footer-top-wrapper">
          <a
            href="index-2.html"
            className="footer-logo wow fadeInUp"
            data-wow-delay=".3s"
          >
            <img src="assets/images/white-logo.png" alt="img" />
          </a>
          <div className="social-icon wow fadeInUp" data-wow-delay=".5s">
            <a target="new" href="https://in.linkedin.com/company/zealthix">
              <i class="fa-brands fa-linkedin-in"></i>
            </a>
            <a target="new" href="https://www.facebook.com/zealthixofficial">
              <i className="fa-brands fa-facebook-f" />
            </a>
            <a target="new" href="https://www.instagram.com/zealthixofficial/">
              <i className="fa-brands fa-instagram" />
            </a>
          </div>
        </div>
        <div className="footer-widget-wrapper style-2">
          <div className="row justify-content-between">
            <div
              className="col-xl-3 col-lg-3 col-md-6 wow fadeInUp"
              data-wow-delay=".3s"
            >
              <div className="footer-widget-items mt-30">
                <div className="widget-title mb-25">
                  <h3 className="font-size-24 text-white font-weight-500">
                    Head office
                  </h3>
                </div>
                <div className="footer-content">
                  <p className="text-white">
                    201 A, SAS Tower, Medicity, Islampur Colony,
                    Sector 38, Gurugram, Haryana 122001, India
                  </p>
                  <ul className="contact-list-2">
                    <li>
                      <a href="tel:7303047811">+91-730-304-7811</a>
                    </li>
                    <li>
                      <a href="mailto:admin@zealthix.com">
                        <span
                        >
                          admin@zealthix.com
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-2 d-none d-xl-block" />
            <div
              className="col-xl-3 col-lg-3 col-md-6 wow fadeInUp"
              data-wow-delay=".5s"
            >
              <div className="footer-widget-items mt-30">
                <div className="widget-title mb-25">
                  <h3 className="font-size-24 text-white font-weight-500">
                    Quick Link
                  </h3>
                </div>
                <div className="user-links-area">
                  <ul className="user-links">
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>
                      <Link to="/plans">Plans</Link>
                    </li>
                    <li>
                      <Link to="/contact">Contact Us</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className="col-xl-3 col-lg-3 col-md-6 wow fadeInUp"
              data-wow-delay=".7s"
            >
              <div className="footer-widget-items mt-30">
                <div className="widget-title mb-25">
                  <h3 className="font-size-24 text-white font-weight-500">
                    Terms & Policies
                  </h3>
                </div>
                <ul className="user-links">
                  <li>
                    <Link to="/term-of-use">Term of Use</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/cancellation-policy">Cancellation Policy</Link>
                  </li>
                  <li>
                   <Link to="/shipping-delivery-policy">Shipping And Delivery Policy</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <p className="footer-text wow fadeInUp" data-wow-delay=".3s">
          Copyright © 2025 Zealthix Technologies Pvt. Ltd. All Rights Reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;
